import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import DataTableLayout from "layouts/DatatableLayout";
import ReportDateRangeSelect, { getReportDateRange } from "layouts/ReportDateRangeSelect";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { getReportShippingCostAudit } from "../../redux/handlers/report/getReportShippingCostAudit.handler";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
var numberFormat = function(value) {
    return Number(value || 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};
var filterSelectStyles = {
    control: function(base) {
        return _object_spread_props(_object_spread({}, base), {
            minHeight: 46,
            height: 46
        });
    },
    valueContainer: function(base) {
        return _object_spread_props(_object_spread({}, base), {
            height: 44,
            padding: "0 8px"
        });
    },
    indicatorsContainer: function(base) {
        return _object_spread_props(_object_spread({}, base), {
            height: 44
        });
    },
    menuPortal: function(base) {
        return _object_spread_props(_object_spread({}, base), {
            zIndex: 9999
        });
    }
};
var SummaryCard = function(param) {
    var icon = param.icon, title = param.title, value = param.value, unit = param.unit, color = param.color, background = param.background;
    return /*#__PURE__*/ _jsx(Card, {
        className: "card-st-3 h-100",
        style: {
            background: background
        },
        children: /*#__PURE__*/ _jsxs(Card.Body, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex align-items-center gap-2 mb-2",
                    style: {
                        color: color
                    },
                    children: [
                        icon,
                        /*#__PURE__*/ _jsx("span", {
                            className: "fw-bold",
                            children: title
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "fs-24 fw-bold text-end",
                    children: [
                        value,
                        " ",
                        /*#__PURE__*/ _jsx("span", {
                            className: "fs-14 fw-normal",
                            children: unit
                        })
                    ]
                })
            ]
        })
    });
};
export function ReportShippingCostAudit() {
    var dispatch = useAppDispatch();
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var reportReducer = useAppSelector(function(state) {
        return state.getReportShippingCostAuditReducer;
    });
    var initialRange = getReportDateRange("months_1");
    var _useState = _sliced_to_array(useState("months_1"), 2), dateRange = _useState[0], setDateRange = _useState[1];
    var _useState1 = _sliced_to_array(useState(initialRange.startDate), 2), startDate = _useState1[0], setStartDate = _useState1[1];
    var _useState2 = _sliced_to_array(useState(initialRange.endDate), 2), endDate = _useState2[0], setEndDate = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), saleId = _useState3[0], setSaleId = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), shopId = _useState4[0], setShopId = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), branchId = _useState5[0], setBranchId = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), rows = _useState6[0], setRows = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), filterRows = _useState7[0], setFilterRows = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        total_reservations: 0,
        total_reserve_net: 0,
        total_actual_delivery_net: 0
    }), 2), summary = _useState8[0], setSummary = _useState8[1];
    var saleOptions = useMemo(function() {
        return Array.from(new Map(filterRows.filter(function(row) {
            return row.sale_id;
        }).map(function(row) {
            return [
                row.sale_id,
                {
                    value: row.sale_id,
                    label: row.sale_name
                }
            ];
        })).values());
    }, [
        filterRows
    ]);
    var shopOptions = useMemo(function() {
        var map = new Map();
        filterRows.forEach(function(row) {
            if (row.shop_id) {
                map.set(row.shop_id, {
                    value: row.shop_id,
                    label: row.shop_name
                });
            }
        });
        return Array.from(map.values());
    }, [
        filterRows
    ]);
    var branchOptions = useMemo(function() {
        return Array.from(filterRows.filter(function(row) {
            return !shopId || Number(row.shop_id) === Number(shopId);
        }).reduce(function(map, row) {
            if (row.branch_id && !map.has(row.branch_id)) {
                map.set(row.branch_id, {
                    value: row.branch_id,
                    label: row.branch_name || "-"
                });
            }
            return map;
        }, new Map()).values());
    }, [
        filterRows,
        shopId
    ]);
    useEffect(function() {
        dispatch(getReportShippingCostAudit({
            sdate: startDate ? moment(startDate).format("YYYY-MM-DD") : "",
            edate: endDate ? moment(endDate).format("YYYY-MM-DD") : "",
            saleid: saleId || undefined,
            shopid: shopId || undefined,
            branchid: branchId || undefined
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        startDate,
        endDate,
        saleId,
        shopId,
        branchId
    ]);
    useEffect(function() {
        setIsLoading(reportReducer.isFetching);
        if (reportReducer.data) {
            var _reportReducer_data;
            var data = ((_reportReducer_data = reportReducer.data) === null || _reportReducer_data === void 0 ? void 0 : _reportReducer_data.data) || reportReducer.data;
            var datalist = (data === null || data === void 0 ? void 0 : data.datalist) || [];
            setRows(datalist);
            setFilterRows(function(current) {
                var map = new Map(current.map(function(row) {
                    return [
                        row.rs_reserve_id,
                        row
                    ];
                }));
                datalist.forEach(function(row) {
                    return map.set(row.rs_reserve_id, row);
                });
                return Array.from(map.values());
            });
            setSummary((data === null || data === void 0 ? void 0 : data.summary) || {});
        } else if (reportReducer.isError) {
            setRows([]);
            setSummary({});
        }
    }, [
        reportReducer
    ]);
    var handleDateRangeChange = function(preset) {
        setDateRange(preset);
        var range = getReportDateRange(preset);
        if (range) {
            setStartDate(range.startDate);
            setEndDate(range.endDate);
        }
    };
    var columns = [
        {
            name: "ชื่อร้านค้า",
            selector: function(row) {
                return row.shop_name;
            },
            sortable: true
        },
        {
            name: "สาขา",
            selector: function(row) {
                return row.branch_name;
            },
            sortable: true
        },
        {
            name: "รหัสใบจอง",
            selector: function(row) {
                return row.reserve_code;
            },
            center: true
        },
        {
            name: "มูลค่าจอง",
            selector: function(row) {
                return row.reserve_net;
            },
            right: true,
            cell: function(row) {
                return numberFormat(row.reserve_net);
            }
        },
        {
            name: "มูลค่าส่งจริง",
            selector: function(row) {
                return row.actual_delivery_net;
            },
            right: true,
            cell: function(row) {
                return numberFormat(row.actual_delivery_net);
            }
        },
        {
            name: "วันที่จัดส่งจริง",
            selector: function(row) {
                return row.actual_delivery_date;
            },
            center: true,
            cell: function(row) {
                return row.actual_delivery_date ? moment.parseZone(row.actual_delivery_date).format("DD/MM/YYYY") : "-";
            }
        },
        {
            name: "วันที่จอง",
            selector: function(row) {
                return row.reserve_date;
            },
            center: true,
            cell: function(row) {
                return row.reserve_date ? moment.parseZone(row.reserve_date).format("DD/MM/YYYY HH:mm") : "-";
            }
        },
        {
            name: "เซลล์",
            selector: function(row) {
                return row.sale_name;
            },
            sortable: true
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        className: "pagezoom",
        children: [
            /*#__PURE__*/ _jsx("nav", {
                "aria-label": "breadcrumb",
                className: "mt-2",
                children: /*#__PURE__*/ _jsxs("ol", {
                    className: "breadcrumb fs-16 ps-0 mb-1",
                    children: [
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item",
                            children: "รายงาน"
                        }),
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item active",
                            children: "รายงานตรวจสอบค่าขนส่ง"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "fs-24 mb-3",
                children: "รายงานตรวจสอบค่าขนส่ง"
            }),
            /*#__PURE__*/ _jsxs(Row, {
                className: "g-3 mb-3",
                children: [
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        md: 4,
                        children: /*#__PURE__*/ _jsx(SummaryCard, {
                            icon: /*#__PURE__*/ _jsx(ReceiptLongIcon, {}),
                            title: "จำนวนใบจองทั้งหมด",
                            value: Number(summary.total_reservations || 0).toLocaleString(),
                            unit: "ใบ",
                            color: "#2563eb",
                            background: "#eff6ff"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        md: 4,
                        children: /*#__PURE__*/ _jsx(SummaryCard, {
                            icon: /*#__PURE__*/ _jsx(AccountBalanceWalletIcon, {}),
                            title: "รวมมูลค่าจอง",
                            value: numberFormat(summary.total_reserve_net),
                            unit: "",
                            color: "#7c3aed",
                            background: "#f5f3ff"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        md: 4,
                        children: /*#__PURE__*/ _jsx(SummaryCard, {
                            icon: /*#__PURE__*/ _jsx(LocalShippingIcon, {}),
                            title: "รวมมูลค่าส่งจริง",
                            value: numberFormat(summary.total_actual_delivery_net),
                            unit: "",
                            color: "#059669",
                            background: "#ecfdf5"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Card, {
                className: "card-st-3 mb-3",
                children: /*#__PURE__*/ _jsx(Card.Body, {
                    children: /*#__PURE__*/ _jsxs(Row, {
                        className: "g-3 align-items-end",
                        children: [
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                md: 3,
                                xl: 2,
                                children: /*#__PURE__*/ _jsx(ReportDateRangeSelect, {
                                    value: dateRange,
                                    onChange: handleDateRangeChange,
                                    groupClassName: "form-st-3 mb-0",
                                    controlHeight: 46
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                md: 3,
                                xl: 2,
                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                    className: "form-st-3 mb-0",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Label, {
                                            className: "mb-1",
                                            children: "วันที่ส่งจริงเริ่มต้น"
                                        }),
                                        /*#__PURE__*/ _jsx(DatePicker, {
                                            selected: startDate,
                                            onChange: function(date) {
                                                setDateRange("custom");
                                                setStartDate(date);
                                            },
                                            dateFormat: "dd/MM/yyyy",
                                            className: "form-control",
                                            style: {
                                                height: 46
                                            },
                                            wrapperClassName: "w-100",
                                            maxDate: endDate,
                                            isClearable: true
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                md: 3,
                                xl: 2,
                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                    className: "form-st-3 mb-0",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Label, {
                                            className: "mb-1",
                                            children: "วันที่ส่งจริงสิ้นสุด"
                                        }),
                                        /*#__PURE__*/ _jsx(DatePicker, {
                                            selected: endDate,
                                            onChange: function(date) {
                                                setDateRange("custom");
                                                setEndDate(date);
                                            },
                                            dateFormat: "dd/MM/yyyy",
                                            className: "form-control",
                                            style: {
                                                height: 46
                                            },
                                            wrapperClassName: "w-100",
                                            minDate: startDate,
                                            isClearable: true
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                md: 3,
                                xl: 2,
                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                    className: "form-st-3 mb-0",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Label, {
                                            className: "mb-1",
                                            children: "เซลล์"
                                        }),
                                        /*#__PURE__*/ _jsx(Select, {
                                            options: saleOptions,
                                            isClearable: true,
                                            placeholder: "ทั้งหมด",
                                            styles: filterSelectStyles,
                                            menuPortalTarget: document.body,
                                            menuPosition: "fixed",
                                            onChange: function(o) {
                                                return setSaleId((o === null || o === void 0 ? void 0 : o.value) || "");
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                md: 3,
                                xl: 2,
                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                    className: "form-st-3 mb-0",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Label, {
                                            className: "mb-1",
                                            children: "ร้านค้า"
                                        }),
                                        /*#__PURE__*/ _jsx(Select, {
                                            options: shopOptions,
                                            isClearable: true,
                                            placeholder: "ทั้งหมด",
                                            styles: filterSelectStyles,
                                            menuPortalTarget: document.body,
                                            menuPosition: "fixed",
                                            onChange: function(o) {
                                                setShopId((o === null || o === void 0 ? void 0 : o.value) || "");
                                                setBranchId("");
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                md: 3,
                                xl: 2,
                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                    className: "form-st-3 mb-0",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Label, {
                                            className: "mb-1",
                                            children: "สาขา"
                                        }),
                                        /*#__PURE__*/ _jsx(Select, {
                                            options: branchOptions,
                                            isClearable: true,
                                            placeholder: "ทั้งหมด",
                                            styles: filterSelectStyles,
                                            menuPortalTarget: document.body,
                                            menuPosition: "fixed",
                                            value: branchOptions.find(function(o) {
                                                return Number(o.value) === Number(branchId);
                                            }) || null,
                                            onChange: function(o) {
                                                return setBranchId((o === null || o === void 0 ? void 0 : o.value) || "");
                                            }
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Card, {
                className: "card-st-3",
                children: /*#__PURE__*/ _jsx(Card.Body, {
                    className: "p-0",
                    children: /*#__PURE__*/ _jsx(DataTableLayout, {
                        item: rows,
                        columns: columns,
                        isSelectRows: false,
                        PerPage: 20
                    })
                })
            })
        ]
    });
}
